import {
  Popup,
  TPopupComponent,
} from '../../../../../../../../../shared/components/popup/popup.abstract.tsx';
import { TPopupDefaultActions } from '../../../../../../../../../shared/components/popup/services/popup.service.ts';
import { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPopup } from './content.popup.tsx';
import { map } from 'rxjs';

export class QuantityDiscountPopup extends Popup<IQuantityDiscountPopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;
    this.Component = () => {
      const Wrapper = useMemo(() => this.Wrapper, []);
      const { t } = useTranslation();
      const [popupTitle, setPopupTitle] = useState('');

      useEffect(() => {
        stream
          .actionListener('open')
          .pipe(map(({ title }) => `${t('settings.quantity_discount')} | ${title}`))
          .subscribe(setPopupTitle);
      }, []);

      return (
        <Wrapper
          stream={stream}
          slotProps={{ paper: { sx: { maxWidth: 1500, width: '100%' } } }}
          fullWidth
          {...{ popupTitle }}
        >
          <ContentPopup {...{ stream }} />
        </Wrapper>
      );
    };
  }
}

export interface IQuantityDiscountPopup {
  action: TPopupDefaultActions;
  id: string;
  title: string;
}
